<template>
  <div class="columns is-multiline">
    <div class="column is-half-tablet">
      <div class="information">
        <div class="field">
          <h1> Where could you join a meet? </h1>
          <div class="control has-icons-left">
            <div class="select" title="Country">
              <select v-model="userCountry">
                <option value="">Country:</option>
                <option value="be">Belgium</option>
                <option value="nl">Netherlands</option>
                <option value="eu">Both</option>
              </select>
            </div>
            <div class="icon is-small is-left">
              <flag :iso="userCountry"/>
            </div>
          </div>
        </div>
        <div class="field" v-bind:class="{ disabled: !userCountry }">
          <h1>When could you join a meet?</h1>
          <p>Click once to indicate you can go,
            twice for maybe and again if you can't come on that date after all.</p>
          <!--<p>July: NL, Aug: both?</p>-->
          <div class="heading columns is-mobile">
            <div class="column">Legend:</div>
            <div class="column">
              <colorExample classes="highlighted" content="Can Join"/>
            </div>
            <div class="column">
              <colorExample classes="highlighted2" content="Maybe"/>
            </div>
            <div class="column">
              <colorExample classes="cant" content="Can't come"/>
            </div>
          </div>
          <datepicker
              ref="picker"
              :highlighted="highlighted"
              :disabledDates="disabledDates"
              :inline="true"
              :minimumView="'day'"
              :maximumView="'day'"
              :selectedDate="selectedDate"
              @opened="true"
              @selected="dateSelected"
              :day-custom-classes="myDayStatusClasses"
              :day-cell-content="dayCellContent"
              :monday-first="true"
          ></datepicker>
          <div class="heading columns is-mobile">
            <div class="column">Legend:</div>
            <div class="column">
              <colorExample classes="highlighted" content="Can Join"/>
            </div>
            <div class="column">
              <colorExample classes="highlighted2" content="Maybe"/>
            </div>
            <div class="column">
              <colorExample classes="cant" content="Can't come"/>
            </div>
          </div>
        </div>
        <p>If your joining is more complicated than this please let me know in a pm ;)</p>
      </div>
    </div>
    <div class="column date-info is-half-tablet">
      <article class="message">
        <vb-switch v-if="isAdmin" type="danger" size="large" v-model="isDisableMode"/>
        <h2 class="align-right">
          View-only mode:
          <vb-switch type="success" size="large" v-model="isReadOnlyMode"/>
        </h2>
        <div class="message-header">
          <p v-if="currentDate">{{ new Date(currentDate).toLocaleDateString() }}</p>
          <colorExample
              v-if="currentDate"
              :classes="this.myDayStatusClasses(currentDate)"
              :content="this.getTodayStatus(currentDate, true)"/>
          <p v-else>No date selected. {{ currentDate }}</p>
        </div>
        <div class="message-body">
          <dl v-if="currentDetailsKey && availableDates[currentDetailsKey]">
            <dt v-if="availableDates[currentDetailsKey].CANGO">Can go:</dt>
            <dd :key="`cango-${$key}`"
                v-for="(dt, $key) in availableDates[currentDetailsKey].CANGO">
              <flag :iso="dt.country"/>
              <!--{{ $key }}-->
              {{ dt.name }}
            </dd>
            <dt v-if="availableDates[currentDetailsKey].MAYBE">Maybe:</dt>
            <dd :key="`maybe-${$key}`"
                v-for="(dt, $key) in availableDates[currentDetailsKey].MAYBE">
              <flag :iso="dt.country"/>
              {{dt.name}}
              <!--{{ $key }}-->
              <!--{{ dt }}-->
            </dd>
            <dt v-if="availableDates[currentDetailsKey].CANT">Can't:</dt>
            <dd :key="`cant-${$key}`"
                v-for="(dt, $key) in availableDates[currentDetailsKey].CANT">
              {{dt.name}}
            </dd>
          </dl>
        </div>
      </article>

      <details class="column">
        <summary>Your Information (GDPR)</summary>
        <div class="columns well is-multiline">
          <div class="column user">
            <div v-if="fbdata.name" class="list-item">
              <img :src="loginImage">
              <i>{{fbdata.name}}</i>
            </div>
            <div v-if="fbdata.email" class="list-item">
              <img :src="mailImage">
              <i>{{fbdata.email}}</i>
            </div>
            <div v-if="fbdata.personalID" class="list-item">
              <img :src="faceImage">
              <i>{{fbdata.personalID}}</i>
            </div>
            <div v-if="userCountry" class="list-item">
              You can go to:
              <flag :iso="userCountry"/>
              <i>{{userCountry}}</i>
            </div>
          </div>
          <div class="column dates is-full">
            <ul>
              <li>Your dates:
                <details v-if="myDates.past">
                  <summary>past dates</summary>
                  <ul>
                    <li v-bind:key="date.d.getTime()" v-for="date in myDates.past">
                      <i class="is-clickable" v-on:click="showDetails(date.d)">
                        {{date.status}}: {{date.formattedDate}}
                      </i>
                    </li>
                  </ul>
                </details>
              </li>
              <li v-bind:key="date.d.getTime()" v-for="date in myDates.future">
                <i class="is-clickable" v-on:click="showDetails(date.d)">
                  {{date.status}}: {{date.formattedDate}}
                </i>
              </li>
            </ul>
            -
          </div>
          <i class="column is-full">Please send deletion requests to
            <a href="https://www.messenger.com/t/seppe.blanken.1" target="_blank">Avantgarde Blanken</a></i>
        </div>
      </details>
    </div>
  </div>
</template>

<script>
import Firebase from 'firebase/app';
import 'firebase/database';
import datepicker from 'vuejs-datepicker';
import Media from 'vue-media';
import VbSwitch from 'vue-bulma-switch';
import colorExample from '@/components/colorExample';
import idImage from '../assets/id.svg';
import loginImage from '../assets/login.svg';
import mailImage from '../assets/mail.svg';
import faceImage from '../assets/face.svg';


const config = {
  apiKey: 'AIzaSyBzv6o8AHDBgIRI20Nz2o2R6entIXlX-yI',
  authDomain: 'fb-planner.firebaseapp.com',
  databaseURL: 'https://fb-planner.firebaseio.com',
  projectId: 'fb-planner',
  storageBucket: 'fb-planner.appspot.com',
  messagingSenderId: '752559816612',
};
  // Here we are initializing the Firebase connection.
const app = Firebase.initializeApp(config);
const db = app.database();


// Accessing the greetings reference; .ref() takes a URL as its parameter.
// const datesRef = db.ref('testdates');

export default {
  name: 'authenticated',

  /*
             * This section is added to the original CLI-generated App component. This
             * is where VueFire comes into play, allowing us to link our Vue app to
             * Firebase data relatively simply. More information is on the GitHub page:
             *
             * https://github.com/vuejs/vuefire/
             */
  firebase() {
    return {
      // dates: db.ref('testDates'),
      dates: {
        source: db.ref('dates'),
        // optionally bind as an object
        // asObject: true,
        // optionally provide the cancelCallback
        cancelCallback() {
          console.log('cancelCallback', this);
        },
        // this is called once the data has been retrieved from firebase
        readyCallback() {
          console.log('readyCallback', this);
        },
      },
      me: {
        source: db.ref('dates'),
        // optionally bind as an object
        asObject: true,
        // optionally provide the cancelCallback
        cancelCallback() {
          console.log('cancelmeCallback', this);
        },
        // this is called once the data has been retrieved from firebase
        readyCallback() {
          console.log('readymeCallback', this, this.me);
        },
      },
      user: {
        source: db.ref('user'),
        // optionally bind as an object
        asObject: true,
        // // optionally provide the cancelCallback
        // cancelCallback() {
        //   console.log('canceluserCallback', this);
        // },
        // // this is called once the data has been retrieved from firebase
        readyCallback() {
          console.log('readyuserCallback', this, this.user, this.fbdata);
          this.userCountry = this.user[this.fbdata.personalID].country || '';
          console.log('fbdata2', this.fbdata.personalID, this.user[this.fbdata.personalID]);
        },
      },
      admins: {
        source: db.ref('admins'),
        // optionally bind as an object
        asObject: true,
      },
    };
  },
  updated() {
    console.log('updated', this.fbdata.personalID);
    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
  beforeUpdate() {
    console.log('beforeUpdate', this.fbdata.personalID);
    if (!this.userLoaded) {
      console.log(this.userLoaded, 'binding');
      this.userLoaded = true;

      console.log('info', this.fbdata);
      // if (this.fbdata.personalID) {
      //   this.$bindAsObject('user', db.ref(`user/${this.fbdata.personalID}`),
      // null, () => console.log('Ready fired!', this.user), () => console.log('Cancel fired!'));
      // }
    }
    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },
  beforeMount() {
    console.log('beforeMount', this.fbdata.personalID);
  },
  data() {
    console.log('info', this.fbdata, `id: ${this.fbdata.personalID}`);
    const disabledTo = new Date(); // disable dates in the past
    disabledTo.setHours(0, 0, 0, 0);
    return {
      isReadOnlyMode: false,
      isDisableMode: false,
      currentDetails: null,
      currentDetailsKey: null,
      currentDate: null,
      hasChanges: false,
      userLoaded: false,
      userCountry: '',
      idImage,
      loginImage,
      mailImage,
      faceImage,
      selectedDate: '',
      // selectedDateTimes: [],
      // canjoinDateTimes: {
      //   obj: [],
      //   times: [],
      // },
      // selectedMaybeDateTimes: {
      //   obj: [],
      //   times: [],
      // },
      highlighted: {
        dates: [],
      },
      disabledDates: {
        to: disabledTo,
        // days: [1, 2, 3, 4, 5],
        dates: [],
      },
    };
  },
  props: ['fbdata'],
  watch: {
    userCountry(newData, oldData) {
      this.updateUser({
        $key: this.fbdata.personalID,
        name: this.fbdata.name,
        email: this.fbdata.email || null,
        country: newData,
      });
      console.log('Country changed: ', newData, ' | was: ', oldData);
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log('mntNext', this.fbdata, this.fbdata.personalID);
      // Code that will run only after the
      // entire view has been rendered
    });
  },
  created() {
    console.log('created', this.fbdata, this.fbdata.personalID);
    // this.userCountry = this.$firebaseRefs.user.child(this.fbdata.personalID).country || '';
    // console.log('fbdata', this.fbdata.personalID, this.user[this.fbdata.personalID]);
  },
  components: { datepicker, VbSwitch, colorExample, Media },
  computed: {
    availableDates() {
      const dates = this.dates;
      const availableDates = {};
      let d;
      let $key;

      function isDateInArray(array, value) {
        return !!array.find(item => item.getTime() === value.getTime());
      }
      for (let i = 0; i < dates.length; i += 1) {
        d = new Date(dates[i].date);
        d.setHours(0, 0, 0, 0);
        if (d.getTime() > new Date().getTime()) { // time must be in the future
          $key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
          if (!availableDates[$key]) {
            // availableDates[$key][dates[i].status] = availableDates[$key][dates[i].status] || [];
            availableDates[$key] = {
              date: d,
              CANGO: [],
              MAYBE: [],
              CANT: [],
            };
            console.debug('newGD', availableDates[$key]);
          }
          availableDates[$key][dates[i].status].push(
            this.user[dates[i].from] || dates[i].user || { name: (this.isAdmin ? dates[i].from : '<Someone>') });
          // disable dates host can't go
          console.log('debug', dates[i].status, dates[i].from, d);
          if (!this.isAdmin
              && this.admins[dates[i].from]
              && dates[i].status === 'CANT') {
            if (!isDateInArray(this.disabledDates.dates, d)) {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.disabledDates.dates.push(d);
            }
          }
        }
      }
      console.log(availableDates, 'availableDates');
      return availableDates;
    },
    // disabledDates() {
    //
    // },
    myDates() {
      const dates = this.dates;
      const myDates = {
        future: [],
        past: [],
      };
      let d;
      let isFuture;
      let $key;
      for (let i = 0; i < dates.length; i += 1) {
        d = new Date(dates[i].date);
        $key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
        if (dates[i].from === this.fbdata.personalID) {
          const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          // const prnDt = 'Printed on ' + new Date().toLocaleTimeString('en-us', options);
          isFuture = d.getTime() > new Date().getTime();
          // console.log(prnDt);
          myDates[isFuture ? 'future' : 'past'].push( // $key);
            {
              $key,
              d,
              formattedDate: d.toLocaleDateString('en-us', options),
              ...dates[i],
              isFuture,
            });
        }
      }
      console.log(myDates, 'myDates');
      return myDates;
    },
    isAdmin() {
      return this.admins[this.fbdata.personalID];
    },
  },
  methods: {
    getKey(timestamp) {
      const d = new Date(timestamp);
      // const d = (typeof timestamp === 'number') ? new Date(timestamp) : timestamp;
      return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    },
    updateUser(user) {
      console.log('uU', user);
      if (this.$firebaseRefs.user.child(user.$key)) {
        // create a copy of the user
        const copy = {
          ...this.user[user.$key],
          ...user,
        };
        console.log('updateUser', copy);
        // remove the .key attribute
        delete copy.$key;
        this.$firebaseRefs.user.child(user.$key).set(copy);
      } else {
        // insert new item
        this.$firebaseRefs.user.push(user);
      }
    },
    updateAvailableDates(dProp, status) {
      const d = typeof dProp === 'object' ? dProp : new Date(dProp);
      console.log('uAd', d);
      const data = {
        from: this.fbdata.personalID,
        // user: {
        //   id: this.fbdata.personalID,
        //   name: this.fbdata.name,
        //   // email: this.fbdata.email || null,
        // },
        date: d.toUTCString(),
        status, // CANGO | CANT | MAYBE
      };
      const $key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${this.fbdata.personalID}`;
      if (this.$firebaseRefs.dates.child($key)) {
        this.$firebaseRefs.dates.child($key).set(data);
      } else {
        // insert new item
        this.$firebaseRefs.dates.push({
          $key,
          ...data,
        });
      }
    },
    getTodayStatus(dayObj, humanReadable = false) {
      const d = new Date(dayObj.timestamp || dayObj);
      const $key = `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${this.fbdata.personalID}`;
      if (this.me[$key]) {
        if (humanReadable) {
          switch (this.me[$key].status) {
            case 'CANGO':
              return 'Can Join';
            case 'MAYBE':
              return 'Maybe';
            case 'CANT':
              return 'Can\'t come';
            default:
              return this.me[$key].status;
          }
        } else {
          return this.me[$key].status;
        }
      }
      return null;
    },
    dayCellContent(d) {
      const di = this.availableDates[this.getKey(d.timestamp)];
      const template = [`<small>${d.date}</small>`];
      if (di && (
        (di.CANGO && di.CANGO.length)
          || (di.MAYBE && di.MAYBE.length)
      )) {
        template.push('<ul class="count align-right">');
        // let count = 0;
        if (di.CANGO) {
          template.push(`<li>${di.CANGO.length || '&nbsp;'}</li>`);
          // count += di.CANGO.length;
        }
        if (di.MAYBE) {
          template.push(`<li>${di.MAYBE.length || ''}</li>`);
          // count += di.MAYBE.length;
        }
        template.push('</ul>');
        // template.push(`<span class="count">(${count})</span>`);
      }
      return template.join('');
    },
    myDayStatusClasses(d) {
      switch (this.getTodayStatus(d)) {
        case 'MAYBE':
          return { highlighted2: true };
        case 'CANGO':
          return { highlighted: true };
        case 'CANT':
          return { cant: true };
        default:
          return {};
      }
    },
    showDetails(d) {
      console.log('sD1', this.currentDate, this.selectedDate);
      const $key = this.getKey(d.getTime());
      // eslint-disable-next-line no-console
      console.log(d, this.availableDates[$key]);
      this.currentDetails = this.availableDates[$key];
      this.currentDetailsKey = (this.currentDetails) ? $key : null;
      this.currentDate = d.getTime();
      this.selectedDate = this.currentDate;
      console.log('sD', d.getTime());
    },
    dateSelected(d) {
      if (!this.user[this.fbdata.personalID]) {
        this.updateUser({
          $key: this.fbdata.personalID,
          name: this.fbdata.name,
          email: this.fbdata.email || null,
          country: this.userCountry,
        });
      }
      if (this.isReadOnlyMode) {
        return this.showDetails(d);
      } else if (this.isDisableMode) {
        this.$refs.picker.selectedDate = null;
        this.updateAvailableDates(d, 'CANT');
        this.highlighted.dates.splice(this.highlighted.dates.indexOf(d));
        return this.showDetails(d);
      }
      const status = this.getTodayStatus(d);
      // eslint-disable-next-line no-console
      console.log('dS', this.getTodayStatus(d), status, d);
      switch (status) {
        case 'CANGO':
          this.updateAvailableDates(d, 'MAYBE');
          break;
        case 'MAYBE':
          console.log('unselect', d);
          this.$refs.picker.selectedDate = null;
          // this.$refs.picker.setDate(null);
          this.updateAvailableDates(d, 'CANT');
          this.highlighted.dates.splice(this.highlighted.dates.indexOf(d));
          break;
        default:
          this.highlighted.dates.push(d);
          // save to firebase
          console.log(d.toLocaleDateString(), 'localeDatestring');
          this.updateAvailableDates(d, 'CANGO');
      }
      // if (status === 'CANGO') { // was cango, will be MAYBE
      //   console.log('double-select', d, d.getTime());
      //   if (status === 'MAYBE') { // was maybe, will be CANT
      //     console.log('unselect', d);
      //     this.$refs.picker.selectedDate = null;
      //     // this.$refs.picker.setDate(null);
      //     this.updateAvailableDates(d, 'CANT');
      //   } else {
      //     console.log('maybe', d);
      //     this.updateAvailableDates(d, 'MAYBE');
      //   }
      // } else {
      //   this.highlighted.dates.push(d);
      //   // save to firebase
      //   console.log(d.toLocaleDateString(), 'localeDatestring');
      //   this.updateAvailableDates(d, 'CANGO');
      // }
      // console.log('selected', d, this.highlighted.dates);
      // return `${d.date}`;

      console.log('dates', (this.user[this.fbdata.personalID]) ? this.user[this.fbdata.personalID].dates : 'nope');
      console.log('dates2', this.me);
      return this.showDetails(d);
    },
  },
};
</script>

<style>
  #app {
    display: flex;
    flex-direction: column;
    align-items: flex-start
  }

  .today {
    color: blueviolet;
    font-weight: bold;
  }

  details {
    width: 323px;
  }

  details > *:not(summary) {
    padding-left: 0.5em;
  }

  .date-info article {
    width: 300px;
    padding: 0;
    margin: 0.75rem;
  }

  .information {
    width: 300px;
    margin-top: 0;
    display: flex;
    flex-direction: column;
    /*float: right;*/
  }

  .information .heading, .heading .column {
    margin: 0;
    padding: 0;
  }

  .align-right {
    float: right;
    clear-after: end;
  }

  .well {
    background-color: rgb(191, 238, 229);
    margin: auto;
    padding: 1em;
    border-radius: 2em;
    /*display:inline-block;*/
  }

  .login {
    width: 200px;
    margin: auto;
  }

  .list-item:first-child {
    margin: 0;
  }

  .list-item {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }

  .button {
    margin: auto;
  }

  dt {
    font-weight: bold;
  }

  .cant, .highlighted, .highlighted2 {
    font-weight: bold;
  }

  .cant {
    /*background-color: rgba(255,91,0,0.35)!important;*/
    background-color: rgba(170, 0, 6, 0.83) !important;
    color: white !important;
  }

  .highlighted {
    /*background-color: #cae5ed!important;*/
    background-color: #1375a4 !important;
    color: white !important;
  }

  .highlighted2 {
    background-color: azure !important;
    color: initial !important;
  }

  .hidden {
    display: none;
  }

  .smaller {
    /*transform: translate(-25%, -10%) scale(0.7, 0.7);*/
    transform: scale(0.8);
    transform-origin: top left;
    margin-bottom: -3rem;
  }

  .heading {
    text-transform: initial;
  }

  ul.count li:not(:first-child) {
    font-weight: initial;
  }

  ul.count li {
    padding-top: 0.2em;
    line-height: 1em;
  }

  h1 {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .message-header {
    width: 100%;
  }

  .column.dates {
    margin-top: -1.5em;
  }

  .is-clickable {
    cursor: pointer;
  }
  .disabled {
    opacity: .5;
  }

</style>



// WEBPACK FOOTER //
// src/components/Authenticated.vue